/*
 * (C) Behaviour Interactive Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * This file is proprietary and confidential
 */

export const getViewerCountryHeader = async (): Promise<string> => {
  try {
    const response = await fetch(document.location.href, { method: 'GET' });
    const viewerCountryHeader = response.headers.get('cloudfront-viewer-country') || 'CA';
    return viewerCountryHeader;
  } catch (error) {
    console.error('Failed to fetch viewer country code:', error);
    return 'CA';
  }
};

export const getViewerPlatform = () => {
  const userAgent = navigator.userAgent || 'unknown';
  const supportMultiTouch = navigator.maxTouchPoints > 1;
  const isMobile = /Mobi|Android/i.test(userAgent);

  if (supportMultiTouch && isMobile) {
    return 'Mobile';
  } else if (userAgent !== 'unknown') {
    return 'Desktop';
  } else {
    return 'Unknown';
  }
};
